import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ALERTS } from 'src/app/common';
import { IRole, IUser } from 'src/app/models';
import { AlertService, BlockUiHandlerService, PermissionService, StorageService, UserService } from 'src/app/services';
import { RoleService } from 'src/app/services/role.service';

@Component({
  selector: 'app-rol-assigns',
  templateUrl: './rol-assigns.component.html',
  styleUrls: ['./rol-assigns.component.css']
})
export class RolAssignsComponent implements OnInit {
  //(VARBOX)
  assignedRoles: IRole[];
  modalReference: NgbModalRef;
  roles: IRole[];
  userControl: FormControl;
  users: IUser[];

  constructor(private userService: UserService, 
    private roleService: RoleService, 
    private permissionService: PermissionService,
    private alertService: AlertService, 
    private formBuilder: FormBuilder, 
    private modalService: NgbModal,  
    private blockUiService: BlockUiHandlerService, 
    private storageService: StorageService) { }

  ngOnInit(): void {
    this.InitVariables();
    this.LoadData();
  }

  InitVariables(): void {
    this.users = [];
    this.assignedRoles = [];
    this.roles = [];
    this.ResetUserControl();
  }

  LoadData(): void {
    this.GetUsers();
  }

  GetUsers(): void {
    this.blockUiService.Start(1);
    this.userService.Get().subscribe(next => {
      this.blockUiService.Stop();
      if (next.Result) {
        this.users = next.Users;
        this.users = next.Users.filter(x => x.IsActive);
        this.users.forEach(x => x.IsSelected = false);
        if (this.users.length > 0) {
          this.users[0].IsSelected = true;
          this.SelectUser(this.users[0]);
        }
      }
      else {
        this.alertService.ShowSmallCornerAlert(`Error: ${next?.ErrorInfo?.Message || ''}`, ALERTS.warning);
      }
    }, error => {
      this.blockUiService.Stop();
      this.alertService.ShowSmallCornerAlert(`Error: ${error}`, ALERTS.warning);
    });
  }

  ResetUserControl(): void {
    this.userControl = new FormControl(-1);
  }

  drop(event: CdkDragDrop<string[]>, _isOnRoleTab = true) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex);

      this.userService.PutByRole(this.users.find(x => x.IsSelected).Id, this.assignedRoles).subscribe(next => {
        if (next.Result) {
          const PLURALIZED = this.assignedRoles.length > 0 ? 's' : '';
          this.alertService.ShowSmallCornerAlert(`Role${PLURALIZED} asignado${PLURALIZED}`, ALERTS.success);
          this.OverridePermissions();
        }
        else {
          this.alertService.ShowSmallCornerAlert(`Error: ${next?.ErrorInfo?.Message || ''}`, ALERTS.warning);
        }
      }, error => {
        this.blockUiService.Stop();
        this.alertService.ShowSmallCornerAlert(`Error: ${error}`, ALERTS.error);
      });
      
    }
  }

    OffsetRoles(_option: number): void {
    if (_option === 0) {
      this.assignedRoles.forEach(x => this.roles.push({ ...x }));
      this.assignedRoles = [];
    }
    else {
      this.assignedRoles.concat(this.roles);
      this.roles.forEach(x => this.assignedRoles.push({ ...x }));
      this.roles = [];
    }

    this.userService.PutByRole(this.users.find(x => x.IsSelected).Id, this.assignedRoles).subscribe(next => {
      if (next.Result) {
        this.alertService.ShowSmallCornerAlert(`Roles asignados`, ALERTS.success);
      }
      else {
        this.alertService.ShowSmallCornerAlert(`Error: ${next?.ErrorInfo?.Message || ''}`, ALERTS.warning);
      }
    }, error => {
      this.blockUiService.Stop();
      this.alertService.ShowSmallCornerAlert(`Error: ${error}`, ALERTS.error);
    });
  }
  
  GetRoles(_filtered = false, _onAssignation = false): void {
    this.blockUiService.Start(1);
    this.roleService.Get().subscribe(next => {
      this.blockUiService.Stop();
      if (next.Result) {
        this.roles = next.Roles;
        if (this.roles.length > 0) {
          this.roles.forEach(x => x.IsSelected = false);
          this.roles[0].IsSelected = true;
        }

        if (_filtered) this.roles = next.Roles.filter(x => x.IsActive);

        if (_onAssignation) {
          this.assignedRoles.forEach(x => {
            this.roles = this.roles.filter(y => y.Id != x.Id);
          });
        }
      }
      else {
        this.alertService.ShowSmallCornerAlert(`Error: ${next?.ErrorInfo?.Message || ''}`, ALERTS.warning);
      }
    }, error => {
      this.blockUiService.Stop();
      this.alertService.ShowSmallCornerAlert(`Error: ${error}`, ALERTS.error);
    });
  }

  SelectUser(_user: IUser): void {
    this.users.forEach(x => x.IsSelected = false);
    this.users.find(x => x.Id === _user.Id).IsSelected = true;

    this.roleService.GetByUser(_user.Id).subscribe(next => {
      if (next.Result) {
        this.assignedRoles = next.Roles;
        this.GetRoles(true, true);
      }
      else {
        this.alertService.ShowSmallCornerAlert(`Error: ${next?.ErrorInfo?.Message || ''}`, ALERTS.error);
      }

    }, error => {
      this.blockUiService.Stop();
      this.alertService.ShowSmallCornerAlert(`Error: ${error}`, ALERTS.error);
    });
  }

  private OverridePermissions(): void {
    const USER = JSON.parse(this.storageService.GetCurrentSession());
    if (USER) {
      this.permissionService.GetPermissionsByUser(+USER.Id).subscribe(next => {
        if (next.Result && next.Permissions && next.Permissions.length > 0) {
          this.storageService.SetPermissions(next.Permissions);
        }
        else {
          this.alertService.ShowSmallCornerAlert(`No se pudieron recargar los permisos`, ALERTS.warning);
        }
      }, error => {
        this.alertService.ShowSmallCornerAlert(`No se pudieron recargar los permisos`, ALERTS.warning);
      });
    }
    else {
      this.alertService.ShowSmallCornerAlert(`No se pudieron recargar los permisos`, ALERTS.warning);
    }
  }

}
